import { ApptStatusMessage } from '@/constants';
import { Appointment } from '@/types';
import { addDays, calculateDateTimeDifference, convertDateFormat, formatDateFormat, isApptEditable } from '@/util';

const isApptAvailable = (appointment: Appointment) => {
  const { daysLimit, isBeforeSelected, stageDatePropertyValue } = appointment.appointmentType;
  if (daysLimit && stageDatePropertyValue) {
    const appointmentDate = new Date();
    return isBeforeSelected ? appointmentDate <= calculateDateTimeDifference(stageDatePropertyValue, daysLimit, true) : appointmentDate >= addDays(stageDatePropertyValue, daysLimit);
  }
  return true;
};

const getScheduledApptStatus = (appointment: Appointment) => {
  const apptDate = convertDateFormat(appointment.appointmentDate);
  return Date.parse(apptDate) < Date.parse(formatDateFormat(new Date(), 'YYYY-MM-DD')) ? ApptStatusMessage.Completed : !isApptEditable(appointment.appointmentStartTime, appointment.isFromFeedAppointment, appointment.appointmentType.customerCanScheduleAppointment) ? ApptStatusMessage.Immutable : '';
};

const newApptStatus = (appointment: Appointment) => {
  return !appointment.appointmentType.customerCanScheduleAppointment ? ApptStatusMessage.AdminScheduled : !isApptAvailable(appointment) ? ApptStatusMessage.NotAvailable : ApptStatusMessage.Pending;
};

const getAppointmentStatus = (appointment: Appointment) => {
  if (appointment.appointmentDate) {
    return getScheduledApptStatus(appointment);
  } else {
    return newApptStatus(appointment);
  }
}

const getSortFieldValues = (appt1: Appointment, appt2: Appointment, sortField: string) => {
  let fa = '' as Date | string;
  let fb = '' as Date | string;
  switch (sortField) {
    case 'Date':
      fa = appt1.appointmentStartTime;
      fb = appt2.appointmentStartTime;
      break;

    case 'Type':
      fa = appt1.appointmentType.title.toLowerCase();
      fb = appt2.appointmentType.title.toLowerCase();
      break;

    case 'Stage':
      fa = appt1.appointmentType.stage.toLowerCase();
      fb = appt2.appointmentType.stage.toLowerCase();
      break;

    case 'TeamMember':
      fa = `${appt1.teamMember.firstName} ${appt1.teamMember.lastName}`.toLowerCase();
      fb = `${appt2.teamMember.firstName} ${appt2.teamMember.lastName}`.toLowerCase();
      break;

    default:
      break;
  }
  return {
    fa,
    fb
  };
}

const addHtmlToText = (text: string) => `<span class="font-bold">${text}</span>`;

const searchAndHighlightText = (searchResults: Appointment[], searchText: string) => {
  const results = [] as Appointment[];
  searchResults.forEach(item => {
    // const regex = new RegExp(searchText, 'gi');
    if (item.appointmentType.title.includes(searchText)) {
      // const highlightedText = item.appointmentType.title.replace(regex, (str) => addHtmlToText(str));
      // item.appointmentType.title = highlightedText;
      results.push(item);
    }
  });
  return results;
}

export { getAppointmentStatus, getSortFieldValues, searchAndHighlightText };
